import { createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { v4 as uuidv4 } from 'uuid';
import {
  AssignErrorId,
  LoadErrorLogsCols,
  LogFailed,
  LogItemsPerPageChanged,
  LogOrderingChanged,
  LogOrderingInit,
  LogPagingChanged,
  LogSortingChanged,
  LogSortingInit,
  LogSuccess,
  ProgressChanged,
} from '../actions/error-logs-actions';
import { CloseSidenav } from '../actions/side-nav.actions';
import { ErrorLogsState } from '../models/bulk.models';

export const errorLogsAdapter = createEntityAdapter<any>();

const initialState: ErrorLogsState = errorLogsAdapter.getInitialState({
  displayedColumns: {},
  importJobId: 0,
  itemsPerPage: [5, 10, 20, 50],
  itemsNumber: 10,
  selectedSortField: '',
  selectedOrder: '',
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
  totalPages: 0,
  sortFieldOptions: [],
  orderFieldOptions: [],
  logsLoaded: false,
});

export const ErrorLogsReducer = createReducer(
  initialState,
  on(LogSuccess, (state, { res }) => {
    const data = res.payload.data.map((m: any) => ({ ...m, id: uuidv4() }));

    return {
      ...errorLogsAdapter.setAll(data, state),
      totalPages: res.payload.filterResults?.totalResults,
    };
  }),
  on(ProgressChanged, (state) => ({
    ...state,
    logsLoaded: true,
  })),
  on(LogFailed, () => initialState),
  on(AssignErrorId, (state, { importJobId }) => ({
    ...state,
    importJobId,
  })),
  on(LogSortingInit, (state, { sortFieldOptions, selectedSortField }) => ({
    ...state,
    sortFieldOptions,
    selectedSortField,
  })),
  on(LogOrderingInit, (state, { orderFieldOptions, selectedOrder }) => ({
    ...state,
    orderFieldOptions,
    selectedOrder,
  })),
  on(LogItemsPerPageChanged, (state, { itemsNumber }) => ({
    ...state,
    itemsNumber,
  })),
  on(LogSortingChanged, (state, { selectedSortField }) => ({
    ...state,
    selectedSortField,
  })),
  on(LogOrderingChanged, (state, { selectedOrder }) => ({
    ...state,
    selectedOrder,
  })),
  on(LogPagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(LoadErrorLogsCols, (state, { displayedColumns }) => ({
    ...state,
    displayedColumns,
  })),
  on(CloseSidenav, () => initialState),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
